import { PageBreadcrumbsWithLinks, PrimaryPageActions } from '@/components'
import { dashboardShellBreadcrumb } from '@/constants/adminPage'
import { PermissionTypes } from '@/constants/permissions'
import { usePermission } from '@/hooks/usePermission'
import React, { lazy, useState } from 'react'
import { useTranslation } from 'react-i18next'
import withSuspense from '@/helpers/suspense.helper'
import { PageBody, PageTitle, PageWrapper } from '@/components/PageWrapper'

const ViewPromoCodes = withSuspense(lazy(() => import('./Components/ViewPromoCodes')))
const AddEditPromoCode = withSuspense(lazy(() => import('./Components/AddEditPromoCode')))
const PromoCodeUsageHistory = withSuspense(lazy(() => import('./Components/PromoCodeUsageHistory')))

const ManagePromoCodes: React.FC = () => {
	const { t } = useTranslation()
	const { userHasPermission } = usePermission()
	const canCreate =
		userHasPermission(PermissionTypes.Permissions_PromoCodes_Create) ||
		userHasPermission(PermissionTypes.Permissions_Tenants_View)
	const [reload, setReload] = useState(false)
	const [editId, setEditId] = useState<number | null>(null)
	const [showModal, setShowModal] = useState(false)
	const [usageHistoryId, setUsageHistoryId] = useState<number | null>(null)

	const pageTitle = t('Manage.PromoCodes.Heading', 'Promo Codes')

	const onActionClick = (id: number, action: string) => {
		if (action === 'Add') {
			setEditId(null)
			setShowModal(true)
		}
		if (action === 'Edit') {
			setEditId(id)
			setShowModal(true)
		}
		if (action === 'Saved') {
			setShowModal(false)
			setReload((r) => !r)
		}
		if (action === 'ViewUsage') {
			setUsageHistoryId(id)
		}
	}

	return (
		<>
			<PageBreadcrumbsWithLinks title={pageTitle} subNames={dashboardShellBreadcrumb(t('Manage.PromoCodes.Breadcrumb', 'Promo Codes'))} />

			<PageWrapper>
				<PageTitle
					actions={
						canCreate ? (
							<PrimaryPageActions>
								<button type="button" className="btn btn-primary" onClick={() => onActionClick(0, 'Add')}>
									<i className="ri-add-line" aria-hidden />
									{t('Manage.PromoCodes.Add', 'Add Promo Code')}
								</button>
							</PrimaryPageActions>
						) : undefined
					}
				/>
				<PageBody>
					<ViewPromoCodes onActionClick={onActionClick} reload={reload} />
				</PageBody>
			</PageWrapper>

			{showModal && <AddEditPromoCode promoCodeId={editId} onClose={() => setShowModal(false)} onSaved={() => onActionClick(0, 'Saved')} />}
			{usageHistoryId != null && <PromoCodeUsageHistory promoCodeId={usageHistoryId} onClose={() => setUsageHistoryId(null)} />}
		</>
	)
}

export default ManagePromoCodes
